var exports = {
  "sM": "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "pW": "DiscoveryBannerTint.module__bannerTintViolet___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "wi": "DiscoveryBannerTint.module__bannerTintBlue___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "gp": "DiscoveryBannerTint.module__bannerTintTeal___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "ZQ": "DiscoveryBannerTint.module__bannerTintGreen___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "j8": "DiscoveryBannerTint.module__bannerTintLime___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "LJ": "DiscoveryBannerTint.module__bannerTintAmber___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "zg": "DiscoveryBannerTint.module__bannerTintCoral___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "zv": "DiscoveryBannerTint.module__bannerTintRose___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "$B": "DiscoveryBannerTint.module__bannerTintMagenta___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
  "KS": "DiscoveryBannerTint.module__bannerTintIndigo___Rk4xV0" + " " + "DiscoveryBannerTint.module__bannerTint___Rk4xV0",
};

module.exports = exports;
